import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';
import { fetchLayout } from 'actions/layoutsActions';
import get from 'lodash/get';

export const QNA_VOTE_ACTION_REQUEST = 'QNA_VOTE_ACTION_REQUEST';
export const QNA_VOTE_ACTION_SUCCESS = 'QNA_VOTE_ACTION_SUCCESS';
export const QNA_VOTE_ACTION_ERROR = 'QNA_VOTE_ACTION_ERROR';

export const GET_QNA_PAGE_REQUEST = 'GET_QNA_PAGE_REQUEST';
export const GET_QNA_PAGE_SUCCESS = 'GET_QNA_PAGE_SUCCESS';
export const GET_QNA_PAGE_ERROR = 'GET_QNA_PAGE_ERROR';
export const RESET_QNA_PAGE_DATA = 'RESET_QNA_PAGE_DATA';

export const GET_ALL_ANSWER_PAGE_REQUEST = 'GET_ALL_ANSWER_PAGE_REQUEST';
export const GET_ALL_ANSWER_PAGE_SUCCESS = 'GET_ALL_ANSWER_PAGE_SUCCESS';
export const GET_ALL_ANSWER_PAGE_ERROR = 'GET_ALL_ANSWER_PAGE_ERROR';
export const RESET_ALL_ANSWER_PAGE_DATA = 'RESET_ALL_ANSWER_PAGE_DATA';

export const QNA_INPUT_TEXT_SUBMIT_REQUEST = 'QNA_INPUT_TEXT_SUBMIT_REQUEST';
export const QNA_INPUT_TEXT_SUBMIT_SUCCESS = 'QNA_INPUT_TEXT_SUBMIT_SUCCESS';
export const QNA_INPUT_TEXT_SUBMIT_ERROR = 'QNA_INPUT_TEXT_SUBMIT_ERROR';
export const QNA_INPUT_TEXT_RESET = 'QNA_INPUT_TEXT_RESET';

export const ANSWER_DELETE_REQUEST = 'ANSWER_DELETE_REQUEST';
export const ANSWER_DELETE_SUCCESS = 'ANSWER_DELETE_SUCCESS';
export const ANSWER_DELETE_ERROR = 'ANSWER_DELETE_ERROR';
export const RESET_ANSWER_DELETE = 'RESET_ANSWER_DELETE';

export const SHOW_MORE_QNA_REQUEST = 'SHOW_MORE_QNA_REQUEST';
export const SHOW_MORE_QNA_SUCCESS = 'SHOW_MORE_QNA_SUCCESS';
export const SHOW_MORE_QNA_ERROR = 'SHOW_MORE_QNA_ERROR';

export const SEARCH_TEXT_QNA_REQUEST = 'SEARCH_TEXT_QNA_REQUEST';
export const SEARCH_TEXT_QNA_SUCCESS = 'SEARCH_TEXT_QNA_SUCCESS';
export const SEARCH_TEXT_QNA_ERROR = 'SEARCH_TEXT_QNA_ERROR';
export const SEARCH_TEXT_QNA_RESET = 'SEARCH_TEXT_QNA_RESET';

function getRequestAction(actionType) {
	return { type: actionType };
}

function getSuccessAction(actionType, data) {
	return { type: actionType, data };
}

function getErrorAction(actionType, error) {
	return { type: actionType, error };
}

export function fetchQNAPageAction(
	requestContext,
	page,
	REQUEST = GET_QNA_PAGE_REQUEST,
	SUCCESS = GET_QNA_PAGE_SUCCESS,
	ERROR = GET_QNA_PAGE_ERROR
) {
	return dispatch => {
		dispatch(getRequestAction(REQUEST));
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/3/page/dynamic/${page}`
			}),
			{ requestContext }
		).then(
			json => {
				const layoutId = get(json['RESPONSE'], ['layout', 'page', 'id']);
				return fetchLayout(layoutId).then(response => {
					let layoutValue = get(response, ['RESPONSE', layoutId, 'value']);
					if (layoutValue) {
						layoutValue = JSON.parse(layoutValue);
					}
					return dispatch(getSuccessAction(SUCCESS, Object.assign(json['RESPONSE'], { layoutValue })));
				});
			},
			err => dispatch(getErrorAction(ERROR, err))
		);
	};
}

export function fetchAllAnswerPageAction(requestContext, page) {
	return fetchQNAPageAction(
		requestContext,
		page,
		GET_ALL_ANSWER_PAGE_REQUEST,
		GET_ALL_ANSWER_PAGE_SUCCESS,
		GET_ALL_ANSWER_PAGE_ERROR
	);
}

export function faqVoteAction(answerParams) {
	return dispatch => {
		dispatch(getRequestAction(QNA_VOTE_ACTION_REQUEST));
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/qna/answers/sentiment',
				acceptErrors: true
			}),
			answerParams
		).then(
			json => dispatch(getSuccessAction(QNA_VOTE_ACTION_SUCCESS, json['RESPONSE'])),
			err => {
				return dispatch(getErrorAction(QNA_VOTE_ACTION_ERROR, err));
			}
		);
	};
}

export function saveQnAInputTextAction(id, type, _reqBody) {
	return dispatch => {
		dispatch(getRequestAction(QNA_INPUT_TEXT_SUBMIT_REQUEST));
		let pathname = `/api/1/qna/questions/${id}/answers`;
		if (type === 'question') {
			pathname = '/api/1/qna/questions';
			_reqBody.productId = id;
		}
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname,
				acceptErrors: true
			}),
			_reqBody
		).then(
			json =>
				dispatch(
					getSuccessAction(QNA_INPUT_TEXT_SUBMIT_SUCCESS, {
						anonymous: _reqBody.anonymous,
						text: _reqBody.text,
						submitState: _reqBody.submitState,
						...json['RESPONSE']
					})
				),
			err => dispatch(getErrorAction(QNA_INPUT_TEXT_SUBMIT_ERROR, err))
		);
	};
}

export function deleteAnswerAction(answerId) {
	return dispatch => {
		dispatch(getRequestAction(ANSWER_DELETE_REQUEST));
		return ApiCaller.delete(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/qna/answers/${answerId}`
			})
		).then(
			json =>
				dispatch(
					getSuccessAction(ANSWER_DELETE_SUCCESS, {
						...json['RESPONSE'],
						id: answerId
					})
				),
			err => dispatch(getErrorAction(ANSWER_DELETE_ERROR, err))
		);
	};
}

export function loadMoreQnAAction(_req) {
	return dispatch => {
		dispatch(getRequestAction(SHOW_MORE_QNA_REQUEST));
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api${_req.url}`
			})
		).then(
			json => {
				const response = json['RESPONSE'];
				(_req.response || []).push(...(response.data || []));
				return dispatch(
					getSuccessAction(SHOW_MORE_QNA_SUCCESS, {
						[_req.id]: {
							response: _req.response,
							params: response.params
						}
					})
				);
			},
			err => dispatch(getErrorAction(SHOW_MORE_QNA_ERROR, err))
		);
	};
}

export function resetDataAction(RESET = RESET_QNA_PAGE_DATA) {
	return dispatch => {
		return dispatch(getRequestAction(RESET));
	};
}

export function resetDeleteDataAction() {
	return resetDataAction(RESET_ANSWER_DELETE);
}

export function resetAllAnswerPageDataAction() {
	return resetDataAction(RESET_ALL_ANSWER_PAGE_DATA);
}

export function resetInputAction() {
	return resetDataAction(QNA_INPUT_TEXT_RESET);
}

export function searchTextQnAAction(searchText, productId, count) {
	return dispatch => {
		dispatch(getRequestAction(SEARCH_TEXT_QNA_REQUEST));
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/ugc/search?searchText=${searchText}&productId=${productId}&count=${count}`,
				acceptErrors: true
			})
		).then(
			json => {
				return dispatch(getSuccessAction(SEARCH_TEXT_QNA_SUCCESS, json['RESPONSE']));
			},
			err => dispatch(getErrorAction(SEARCH_TEXT_QNA_ERROR, err))
		);
	};
}

export function resetSearchTextQnAAction() {
	return resetDataAction(SEARCH_TEXT_QNA_RESET);
}
